/**
 * Constants representing collection IDs for different censuses.
 * @constant {string} CENSUS_1931_COLLECTION_ID - Collection ID for the 1931 Census.
 * @constant {string} CENSUS_OTTOMAN_COLLECTION_ID - Collection ID for the Ottoman Census.
 */
export const CENSUS_1931_COLLECTION_ID = '5000196'
export const CENSUS_OTTOMAN_COLLECTION_ID = '4496121'

/**
 * Fields used in the collection.
 * @constant {Object} FIELDS
 * @property {string} FIELDS.ADDITIONAL_FIELDS - Additional fields.
 * @property {string} FIELDS.AGE - Age field.
 * @property {string} FIELDS.EVENTS - Events field.
 * @property {string} FIELDS.HIGHLIGHTS - Highlights field.
 * @property {string} FIELDS.NAME - Name field.
 * @property {string} FIELDS.OTHER - Other field.
 * @property {string} FIELDS.RELATIONSHIPS - Relationships field.
 * @property {string} FIELDS.SEX - Sex field
 */
export const FIELDS = {
  ADD_REMOVE_FIELDS: 'ADD_REMOVE_FIELDS',
  ADD_REMOVE_PERSON: 'ADD_REMOVE_PERSON',
  AGE: 'AGE',
  EVENTS: 'EVENTS',
  HIGHLIGHTS: 'HIGHLIGHTS',
  NAME: 'NAME',
  OTHER: 'OTHER',
  PRIMARY: 'PRIMARY',
  RACE: 'RACE',
  RELATIONSHIPS: 'RELATIONSHIPS',
  SEX: 'SEX',
}

export const ALL = Object.values(FIELDS)

/**
 * Special collections that require specific handling.
 * @constant {Object} SPECIAL_COLLECTIONS
 * @property {Object} 5000196 - Configuration for the 1931 Census collection.
 * @property {string} 5000196.flag - Feature flag for the 1931 Census edit functionality.
 * @property {string} 5000196.alertMessageKey - Key for the alert message related to the 1931 Census.
 * @property {string} 5000196.alertMessageDefault - Default alert message for the 1931 Census.
 * @property {Array<string>} 5000196.restrictedFields - List of nonEditable fields for the 1931 Census. Can include 'NAME', 'AGE' or even 'HIGHLIGHTS'.
 */

export const SPECIAL_COLLECTIONS = {
  [CENSUS_1931_COLLECTION_ID]: {
    flag: 'rip_sharedImageViewer_1931CensusEdit',
    alertMessageKey: 'index.1931.Census.alert.banner-message',
    alertMessageValue:
      'In order to keep records searchable on FamilySearch, only some fields are available to edit in the 1931 Canada Census.',
    restrictedFields: [FIELDS.EVENTS, FIELDS.RELATIONSHIPS, FIELDS.HIGHLIGHTS, FIELDS.PRIMARY],
  },
  [CENSUS_OTTOMAN_COLLECTION_ID]: {
    flag: 'rip_sharedImageViewer_OttomanCensusEdit',
    restrictedFields: ALL,
  },
}
